import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { QuoteRequestRoutingModule } from './quote-request-routing.module';
import { QuoteRequestComponent } from './quote-request.component';
import { UIModule } from '../../ui/ui.module'
import { ReactiveFormsModule } from '@angular/forms';
import { SlickCarouselModule } from 'ngx-slick-carousel';

@NgModule({
  declarations: [
    QuoteRequestComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    QuoteRequestRoutingModule,
    UIModule,
    SlickCarouselModule
  ]
})
export class QuoteRequestModule { }
